<template>
    <price-change-history is-out-agreement />
</template>

<script>
import PriceChangeHistory from '@/components/PriceChangeHistory.vue'
export default {
    components: {
        PriceChangeHistory
    }
}
</script>
